import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Checkbox, FormControlLabel } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';

import { makeStyles } from '@material-ui/core/styles';
import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';
import { i18n } from '../App.js';

const useStyles = makeStyles(theme => ({
  root: {},
  commitmentList: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  item: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    width: '100%'
  },
  checkboxContainer: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  iconDisabled: {
    opacity: 0.3
  },
  alreadyEngaged: {
    color: theme.pink,
    fontSize: 16,
    marginTop: theme.spacing(2)
  }
}));

const CommitmentList = ({ commitments, disabled }) => {
  // console.log('DRAW COMMITMENTLIST');
  const [globalState, globalDispatch] = useCoolfoodContext();

  const classes = useStyles();

  // We want to pre-select some commitments only at "init time" wo we store it
  const [inited, setInited] = useState(false);

  const [canTakeNewCommitments, setCanTakeNewCommitments] = useState(false);

  function selectCommitment(e) {
    const value = parseInt(e.target.value);
    if (e.target.checked) {
      // Dispatch selection
      globalDispatch({ type: actions.SELECT_COMMITMENT, id: value });
    } else {
      // Dispatch selection
      globalDispatch({ type: actions.UNSELECT_COMMITMENT, id: value });
    }
  }

  // Challenges, auto select commitments if defined as is in happening definition on the Wordpress side
  useEffect(() => {
    let numberOfTakableCommitments = 0;
    if (inited) {
      return;
    }
    commitments.forEach(c => {
      if (
        c.is_selected === true &&
        globalState.selectedCommitments.indexOf(c.id) === -1 &&
        // Do not preselect if commitment is already taken
        (globalState.coolfooder &&
          globalState.coolfooder.commitsAlreadyTaken &&
          globalState.coolfooder.commitsAlreadyTaken.indexOf(c.id) === -1)
      ) {
        numberOfTakableCommitments += 1;
        globalDispatch({ type: actions.SELECT_COMMITMENT, id: c.id });
      } else if (
        // Check if some commitment are not already taken
        globalState.coolfooder &&
        globalState.coolfooder.commitsAlreadyTaken &&
        globalState.coolfooder.commitsAlreadyTaken.indexOf(c.id) === -1
      ) {
        numberOfTakableCommitments += 1;
      }
    });
    if (numberOfTakableCommitments > 0) {
      setCanTakeNewCommitments(true);
    }
    setInited(true);
  }, [
    commitments,
    globalDispatch,
    globalState.coolfooder,
    globalState.selectedCommitments,
    inited
  ]);

  return (
    <div className="root">
      {!canTakeNewCommitments ? (
        <div className={classes.alreadyEngaged}>
          {i18n._('Vous êtes déjà engagé, merci !')}
        </div>
      ) : (
        <div className={classes.commitmentList} id="commitmentList">
          {commitments.map(commitment => {
            const key = `commitment_${commitment.id}`;
            const userCanUnselect = commitment.user_can_unselect
              ? 'userCanUnselect'
              : '';
            const itemDisabled = disabled ? 'itemDisabled' : '';
            const alreadyTaken =
              globalState.coolfooder &&
              globalState.coolfooder.commitsAlreadyTaken &&
              globalState.coolfooder.commitsAlreadyTaken.indexOf(
                commitment.id
              ) !== -1;
            const alreadyTakenStyle = alreadyTaken ? 'alreadyTaken' : '';
            return (
              <div
                key={key}
                className={`${classes.item} ${userCanUnselect} ${itemDisabled} ${alreadyTakenStyle}`}
              >
                <FormControlLabel
                  label={commitment.name}
                  disabled={
                    disabled ||
                    (commitment.is_selected && !commitment.user_can_unselect) ||
                    alreadyTaken
                  }
                  control={
                    <Checkbox
                      value={commitment.id}
                      checked={
                        globalState.selectedCommitments.indexOf(
                          commitment.id
                        ) !== -1
                      }
                      onChange={selectCommitment}
                      disabled={
                        (commitment.is_selected &&
                          !commitment.user_can_unselect) ||
                        disabled
                      }
                    />
                  }
                />
                <IconButton
                  size="small"
                  onClick={() =>
                    globalDispatch({
                      type: actions.SHOW_MODAL,
                      id: commitment.id
                    })
                  }
                  // disabled={disabled}
                >
                  <HelpOutline
                    color="primary"
                    className={disabled ? classes.iconDisabled : null}
                  />
                </IconButton>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

CommitmentList.propTypes = {
  commitments: PropTypes.arrayOf(PropTypes.shape).isRequired,
  disabled: PropTypes.bool
};

CommitmentList.defaultValues = {
  disabled: true
};

export default CommitmentList;
